import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { SortOrder } from "interfaces/SortOrder";
import { IPreferredConditionFilters } from "interfaces/RacingOfficialPCPageState";

const base = "RACING_OFFICIAL_PC_PAGE";

export const SET_ARE_LAST_RACE_PREFERRED_CONDITIONS = `${base}_ARE_LAST_RACE_PREFERRED_CONDITIONS`;
export const SET_ORDER = `${base}_SET_ORDER`;
export const SET_ORDER_BY = `${base}_SET_ORDER_BY`;
export const SET_FILTERS = `${base}_SET_FILTERS`;
export const CLEAR_FILTERS = `${base}_CLEAR_FILTERS`;

export interface RacingOfficialPCPageType {
  type: string;
  areLastRacePreferredConditions?: boolean;
  order: SortOrder;
  orderBy: keyof racehorse360.HorsesCountGroupedByPreferredCondition;
  filters: IPreferredConditionFilters;
}

export const setAreLastRacePreferredConditions = (
  areLastRacePreferredConditions?: boolean
): Partial<RacingOfficialPCPageType> => {
  return {
    type: SET_ARE_LAST_RACE_PREFERRED_CONDITIONS,
    areLastRacePreferredConditions
  };
};

export const setOrder = (
  order: SortOrder
): Partial<RacingOfficialPCPageType> => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (
  orderBy: keyof racehorse360.HorsesCountGroupedByPreferredCondition
): Partial<RacingOfficialPCPageType> => {
  return {
    type: SET_ORDER_BY,
    orderBy
  };
};

export const setPreferredConditionsFilters = (
  filters: IPreferredConditionFilters
): Partial<RacingOfficialPCPageType> => {
  return {
    type: SET_FILTERS,
    filters
  };
};

export const clearPreferredConditionsFilters =
  (): Partial<RacingOfficialPCPageType> => {
    return { type: CLEAR_FILTERS };
  };
